import baseRoute from '../baseRoute';

export default `${baseRoute}/dailyPerDiemTip` as const;
